import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Container, Eyebrow, H2, Stars, btn } from './shared';
import { useSiteConfig } from '../../lib/siteConfig';

const REVIEWS = [
  { quote: 'Selbst als jemand, der mit kaum Wissen gestartet ist, war es sehr verständlich gestaltet.', name: 'Florian', date: 'Juli 2026' },
  { quote: 'Durch die vielen Bildmaterialien und Praxisbeispiele ist der Knoten bei mir schnell geplatzt.', name: 'Qendrim Shabani', date: 'Oktober 2026' },
  { quote: '… der Unterschied zwischen einem Influencer und einem echten Mentor.', name: 'Juan-Emilio Calzado Lamoncha', date: 'Juli 2026' },
  { quote: 'War schon bisschen im Thema Aktien/ETFs drin, aber noch nicht richtig verstanden.', name: 'Boris Bidny', date: 'Juli 2026' },
  { quote: 'Bündelt das komplette Wissen super zusammen!', name: 'Christian Müller', date: 'September 2026' },
  { quote: 'Gibt einem alles mit, was du brauchst: klare Struktur und Strategie.', name: 'Heiko Benz', date: 'Oktober 2026' },
];

const initials = (name) => name.split(/[\s-]+/).filter(Boolean).slice(0, 2).map((p) => p[0]).join('').toUpperCase();

const ReviewCard = ({ r, i, hidden }) => (
  <figure className="flex w-[300px] shrink-0 flex-col rounded-[20px] border border-line bg-navy p-6 sm:w-[360px]"
          aria-hidden={hidden || undefined} data-testid={hidden ? undefined : `testimonial-card-${i}`}>
    <Stars size={15} />
    <blockquote className="mt-4 flex-1 text-[15px] leading-relaxed text-white">„{r.quote}"</blockquote>
    <figcaption className="mt-5 flex items-center gap-3">
      <span className="grid h-10 w-10 shrink-0 place-items-center rounded-full bg-leaf font-display text-xs font-bold text-brand" aria-hidden="true">{initials(r.name)}</span>
      <span>
        <span className="block text-sm font-semibold text-white">{r.name}</span>
        <span className="block text-xs text-ink">Trustpilot · {r.date}</span>
      </span>
    </figcaption>
  </figure>
);

export const Testimonials = () => {
  const { trustpilot_url } = useSiteConfig();
  return (
    <section id="stimmen" className="scroll-mt-20 overflow-hidden border-y border-line bg-navy/40 py-16 sm:py-20" data-testid="testimonials-section">
      <Container className="text-center">
        <Eyebrow>Erfahrungen</Eyebrow>
        <H2>Was ehemalige Mentees sagen</H2>
      </Container>
      <div className="marquee-mask mt-10">
        <div className="marquee-track flex w-max gap-5" data-testid="testimonials-marquee">
          {REVIEWS.map((r, i) => <ReviewCard key={r.name} r={r} i={i} />)}
          {REVIEWS.map((r, i) => <ReviewCard key={`dup-${r.name}`} r={r} i={i} hidden />)}
        </div>
      </div>
      <Container className="mt-10 text-center">
        <a href={trustpilot_url} target="_blank" rel="noopener noreferrer" className={btn.outlineDark} data-testid="testimonials-trustpilot-btn">
          <Stars size={14} /> Alle Bewertungen auf Trustpilot lesen <ArrowRight size={16} aria-hidden="true" />
        </a>
      </Container>
    </section>
  );
};
